export default __webpack_public_path__ + "static/media/roadmap-background-clouds.cc7343b4.svg";